const Groups = {
  GL: 'Gym Leader',
  E4: 'Elite Four',
  R: 'Rival',
  ET: 'Evil Team',
  MB: 'Mini Boss',
  T: 'Titan',
  o: 'Other'
}

export const GuideBossOrder = [ Groups.GL, Groups.E4, Groups.R, Groups.ET, Groups.MB, Groups.T, Groups.o ]
